import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon viewBox="0 0 24 24" boxSize="24px" fill="none" {...props}>
      <path d="M3 3L12 3V21H3L3 3Z" stroke="#FFFFFF" strokeWidth="2"></path>
      <path
        d="M12 3L21 3L21 12H12L12 3Z"
        stroke="#FFFFFF"
        strokeWidth="2"
      ></path>
      <path
        d="M12 12L21 12L21 21L12 21L12 12Z"
        stroke="#FFFFFF"
        strokeWidth="2"
      ></path>
    </Icon>
  )
}

export default IconComp
